<template>
  <div>
    <b-card class="mt-4">
      <div v-show="!isLoaded">
        <Loading ref="loadingSpinner"></Loading>
      </div>
      <div v-if="isLoaded">
        <b-overlay :show="busy" rounded="sm">
          <div class="row pb-3">
            <div class="col">
              <h3>Dostawcy</h3>
            </div>
            <div class="col">
              <button type="button" class="btn btn-primary float-right" @click="OpenNewProducerModal">
                <i class="fas fa-plus-circle fa-1x"></i> Dodaj nowego dostawcę
              </button>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 font-weight-bold">Nazwa</div>
            <div class="col-md-6 font-weight-bold">Akcje</div>
          </div>
          <div class="row p-1" v-for="item in items" :key="item.id">
            <div class="col-md-6">
              <input type="text" :disabled="!item.isEdit" class="form-control" v-model="item.name" />
            </div>
            <div class="col-md-6">
              <div class="row" style="display: flex">
                <button type="button" class="btn btn-primary btn-sm" style="margin-right: 15px"
                  @click="ToggleCertificatesList(item)">
                  <span v-if="!item.showCertificates"> Pokaż Certyfikaty</span>
                  <span v-else> Ukryj Certyfikaty</span>
                </button>

                <button type="button" class="btn btn-primary btn-sm" style="margin-right: 15px"
                  @click="OpenNewCertificateModal(item)">
                  Dodaj certyfikat
                </button>
                <button type="button" class="btn btn-primary btn-sm" @click="OpenChangeNameModal(item)">
                  Zmień nazwę
                </button>
              </div>
            </div>
            <div class="col-md-11" v-if="item.showCertificates">
              <table class="table table-striped table-sm">
                <thead>
                  <tr>
                    <td>Nazwa</td>
                    <td>Ważny od</td>
                    <td>Ważny do</td>
                    <td>Akcje</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="cert in item.certificates" :key="cert.id">
                    <td>{{ cert.name }}</td>
                    <td>{{ cert.validFrom | moment("DD-MM-YYYY HH:mm") }}</td>
                    <td>{{ cert.validTo | moment("DD-MM-YYYY HH:mm") }}</td>
                    <td>
                      <button type="button" class="btn btn-primary btn-sm" @click="OpenChangeCertificateModal(cert)">
                        Edytuj
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-12">
              <hr />
            </div>
          </div>
        </b-overlay>
      </div>
      <AddNewProducerModal @ProducerWasAdded="Getitems()"></AddNewProducerModal>

      <AddCertificateModal @CertificateWasAdded="Getitems()" :producer="selectedProducer"></AddCertificateModal>

      <ProducerChangeName @ProducerChangeName="Getitems()" :producer="selectedProducer"></ProducerChangeName>

      <ChangeCertificate @CertificateWasEdited="Getitems()" :certificate="selectedCertificate"></ChangeCertificate>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import urlConfig from "../../../mixins/url";
import toastr from "../../../mixins/toastr";
import Loading from "../../Common/Loading";
import AddNewProducerModal from "../Modals/Producer/AddNewProducer";
import AddCertificateModal from "../Modals/Producer/AddCertificate";
import ProducerChangeName from "../Modals/Producer/ProducerChangeName";
import ChangeCertificate from "../Modals/Producer/ChangeCertificate";

export default {
  name: "ProducerAdministration",
  components: {
    Loading,
    AddNewProducerModal,
    AddCertificateModal,
    ProducerChangeName,
    ChangeCertificate,
  },
  mixins: [urlConfig, toastr],
  mounted() {
    this.Getitems();
  },
  data() {
    return {
      selectedProducer: {
        name: "",
      },
      selectedCertificate: {
        name: "",
      },
      busy: false,
      items: [],
      isLoaded: false,
    };
  },
  methods: {
    ToggleCertificatesList(item) {
      item.showCertificates = !item.showCertificates;
    },
    OpenNewProducerModal() {
      this.$bvModal.show("AddNewProducer");
    },
    OpenNewCertificateModal(item) {
      this.selectedProducer = item;
      this.$bvModal.show("AddCertificate");
    },
    OpenChangeNameModal(item) {
      this.selectedProducer = item;
      this.$bvModal.show("ProducerChangeName");
    },
    OpenChangeCertificateModal(item) {
      this.selectedCertificate = item;
      this.$bvModal.show("ChangeCertificate");
    },
    Getitems() {
      var url = this.url.serverUrl + this.url.Producer.GetProducer;
      var that = this;
      axios
        .get(url)
        .then(function (response) {
          response.data.forEach(function (entry) {
            entry.showCertificates = false;
          });
          that.items = response.data;
          that.isLoaded = true;
        })
        .catch(function (e) {
          var ref = that.$refs.loadingSpinner;
          ref.ShowErrorMessage("Wystąpił błąd aplikacji!", e);
          that.isLoaded = false;
        });
    },
  },
};
</script>
